import GraphQL from './GraphQL'

class AuthClass {
    signin(cb, params={
        LOGIN : null,
        PASSWORD : null,
        REMEMBER : false
    }) {
        GraphQL.query('auth_signin', {
            'LOGIN : String!' : params.LOGIN,
            'PASSWORD : String!' : params.PASSWORD,
            'REMEMBER : Boolean!' : params.REMEMBER
        }, {}, cb)
    }

    signup(cb, params={
        USER_NAME : null,
        USER_LAST_NAME : null,
        USER_PASSWORD : null,
        USER_CONFIRM_PASSWORD : null,
        USER_EMAIL : null,
        CAPTCHA_WORD : null,
        CAPTCHA_SID : null
    }) {
        GraphQL.query('auth_signup', {
            'USER_NAME : String!' : params.USER_NAME,
            'USER_LAST_NAME : String!' : params.USER_LAST_NAME,
            'USER_PASSWORD : String!' : params.USER_PASSWORD,
            'USER_CONFIRM_PASSWORD : String!' : params.USER_CONFIRM_PASSWORD,
            'USER_EMAIL : String!' : params.USER_EMAIL,
            'CAPTCHA_WORD : String!' : params.CAPTCHA_WORD,
            'CAPTCHA_SID : String!' : params.CAPTCHA_SID
        }, {}, cb)
    }

    logout(cb) {
        GraphQL.query('auth_logout', {
            
        }, {}, cb)
    }

    getCaptchaSID(cb) {
        GraphQL.query('auth_get_captcha_sid', {
            
        }, {}, cb)
    }

    forgotPassword(cb, params={
        EMAIL : null
    }) {
        GraphQL.query('auth_forgot_password', {
            'EMAIL : String!' : params.EMAIL
        }, {}, cb)
    }

    restorePassword(cb, params={
        LOGIN: null,
        CHECKWORD: null,
        NEW_PASSWORD: null,
        CONFIRM_NEW_PASSWORD: null,
    }) {
        GraphQL.query('auth_change_password', {
            'LOGIN : String!' : params.LOGIN,
            'CHECKWORD : String!' : params.CHECKWORD,
            'NEW_PASSWORD : String!' : params.NEW_PASSWORD,
            'CONFIRM_NEW_PASSWORD : String!' : params.CONFIRM_NEW_PASSWORD,
        }, {}, cb)
    }
}

const Auth = new AuthClass()

export default Auth